import { Button, Input } from "components/form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { validateInput } from "validation";
import { survey } from "validation/schema/survey";

const RenameExistblock = ({
  selectedBlock,
  setSelectedBlock,
  setSurveyQuestionArray,
  setBlockArray,
  surveyQuestionArray,
  closeModal,
}) => {
  // set all value
  const [inputData, setInputData] = useState({ blockName: selectedBlock });
  const [error, setError] = useState({});

  const { t } = useTranslation();

  // Validation function handler
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "addNewSuveyBlockSchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  // Function handler
  const updateBlockTitleHandler = () => {
    if (validation()) {
      setSurveyQuestionArray((prevState) => {
        if (prevState[selectedBlock]) {
          const updatedSurveyMcq = {
            ...prevState,
            [inputData?.blockName]: prevState[selectedBlock], // Add new blockName key
          };
          delete updatedSurveyMcq[selectedBlock]; // Remove old blockName key
          return updatedSurveyMcq;
        }
        return prevState;
      });

      // Update block array and selected block
      setBlockArray((prevBlockArray) => {
        // Replace the selected block name in the block array
        return prevBlockArray.map((block) =>
          block?.name === selectedBlock
            ? { ...block, name: inputData?.blockName }
            : block
        );
      });

      setSelectedBlock(inputData?.blockName); // Update the selected block
      closeModal(); // Close modal after successful update
    }
  };

  return (
    <>
      <h3>{t(`CUSTOMIZATION_QUESTION.updateExistBlockTitle`)}</h3>
      <div className="form_field">
        <Input
          type={"text"}
          placeholder={t(
            `CUSTOMIZATION_QUESTION.updateExistBlockTitlePlaceholder`
          )}
          label={t(`CUSTOMIZATION_QUESTION.updateExistBlockTitleLable`)}
          value={inputData?.blockName.trim() || ""}
          onChange={(e) => setInputData({ blockName: e?.target?.value || "" })}
          error={error?.blockName}
        />
      </div>
      <div className="button_wrap button_center">
        <Button className={"light"} onClick={updateBlockTitleHandler}>
          {t(`COMMON.yes`)}
        </Button>
        <Button onClick={closeModal}>{t(`COMMON.no`)}</Button>
      </div>
    </>
  );
};

export default RenameExistblock;
